import lottie from 'lottie-web';

const lottieAnime = {
  animations: {
    splash: null,
    loop: null
  },
  onComplete: null,
  
  init(onComplete) {
    this.onComplete = onComplete;
    this.setupAnimations();
  },
  
  // デバイス判定
  isMobile() {
    return window.matchMedia('(max-width: 991px)').matches;
  },
  
  setupAnimations() {
    const splashContainer = document.getElementById('KvLottie');
    const loopContainer = document.getElementById('KvLottieLoop');
    
    if (!splashContainer || !loopContainer) return;
    
    // デバイスに応じてパスを取得
    const isMobile = this.isMobile();
    const splashPath = isMobile 
      ? splashContainer.dataset.jsonSp 
      : splashContainer.dataset.jsonPc;
    const loopPath = isMobile 
      ? loopContainer.dataset.jsonSp 
      : loopContainer.dataset.jsonPc;
    
    if (!splashPath || !loopPath) return;
    
    // 最初はループアニメーションを非表示
    loopContainer.style.display = 'none';
    
    // スプラッシュアニメーション
    this.animations.splash = lottie.loadAnimation({
      container: splashContainer,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: splashPath,
    });
    
    // ループアニメーション
    this.animations.loop = lottie.loadAnimation({
      container: loopContainer,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: loopPath,
    });
    
    // スプラッシュ完了時のみコールバックを実行
    this.animations.splash.addEventListener('complete', () => {
      splashContainer.style.display = 'none';
      loopContainer.style.display = 'block';
      this.animations.loop.play();
      console.log('Lottie splash animation complete.');
      
      // Splashの完了時のみコールバック実行
      if (this.onComplete) {
        this.onComplete();
        this.onComplete = null;
      }
    });
  }
};

export default lottieAnime;
